import { html } from '@effectivastudio/lit-components/components/application_element/element.js';
import { chatConfig } from '@effectivastudio/lit-components/components/chat/lib/config.js';

import ChatList from '@effectivastudio/lit-components/components/chat_list/element.js';
import ChatListItem from '@effectivastudio/lit-components/components/chat_list_item/element.js';
import '../components/chat_list_item/element.js';

ChatListItem.renderMenu = chatId => {
  return html`<xs-chat-menu role="menu" .chatId=${chatId}></xs-chat-menu>`;
};

ChatList.prototype.renderItem = function renderItem(item) {
  const {
    chatId,
    title,
    kind,
    isMuted,
    unreadMessagesCount,
    imageUrl,
    avatarLabel,
    lastSentMessage,
    lastUpdatedAt,
  } = item;

  return html`
    <xs-chat-list-item
      uid=${chatId}
      ?active=${this.activateChat && chatId === this.activeChatId}
      name=${title}
      kind=${kind}
      ?mute=${isMuted}
      count=${unreadMessagesCount}
      timestamp=${lastUpdatedAt}
      message=${lastSentMessage?.body}
      .messageAttachment=${lastSentMessage?.attachment}
      messageOwnerId=${lastSentMessage?.userId}
      messageOwnerName=${lastSentMessage?.userName}
      ?messageDeleted=${Boolean(lastSentMessage?.deletedAt)}>
      <ef-avatar
        slot="avatar"
        name=${title}
        icon="user"
        .picture=${imageUrl}
        rounded
        label=${kind === 'group' ? avatarLabel : null}>
      </ef-avatar>
    </xs-chat-list-item>
  `;
};

chatConfig.icons.states.final_seen = 'check:solid';
chatConfig.icons.form.attachment = 'paperclip';
chatConfig.icons.form.send = 'arrow-up';
